import { render, staticRenderFns } from "./PreRegSubjects.vue?vue&type=template&id=424e56de&scoped=true"
import script from "./PreRegSubjects.vue?vue&type=script&lang=js"
export * from "./PreRegSubjects.vue?vue&type=script&lang=js"
import style0 from "./PreRegSubjects.vue?vue&type=style&index=0&id=424e56de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424e56de",
  null
  
)

export default component.exports